import React, {useState} from 'react';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import CloseIcon from '@material-ui/icons/Close';

import AreYouSureModal from '../../../components/DialogModals/AreYouSureModal';
import * as adminApi from '../../../services/api/admin';

function FAQsList(props) {
  const {
    providerFaqs,
    setProviderFaqs,
    setFaqModalMode,
    setEditFaqFaqId,
    setShowFaqModal,
    classes: {
      root,
      rigthAlign,
      block,
      inline,
      QAText,
    }
  } = props;

  const [showAreYouSureDialog, setShowAreYouSureDialog] = useState(false);
  const [currentFaq, setCurrentFaq] = useState({});

  const initFaqEdit = (faqId) =>{
    setEditFaqFaqId(faqId)
    setFaqModalMode('edit');
    setShowFaqModal(true);
  }

  const deletFaqClicked = (faq) => {
    setCurrentFaq(faq);
    setShowAreYouSureDialog(true);
  }

  const deletFaq = async (FAQ) => {
      await adminApi.deleteFAQreq(FAQ.id);
      const temp = [...providerFaqs];
      const index = temp.findIndex(faq => faq.id === FAQ.id);
      temp.splice(index,1);
      setProviderFaqs(temp);
      setShowAreYouSureDialog(false);
  }

  return (
    <>
      {providerFaqs.map(faq => (
        <Paper key={faq.id} className={`${root} ${block}`}> 
          <h3 className={inline}><strong>Q:</strong></h3> 
          <IconButton
            className={rigthAlign}
            size="small"
            aria-label="Remove"
            title="Remove"
            color="primary"
            onClick={ ()=> deletFaqClicked(faq) }>
            <CloseIcon/>
          </IconButton>  
          <IconButton
              className={rigthAlign}
              size="small"
              aria-label="Update-FAQ"
              title="Update-FAQ"
              color="primary"
              onClick={() => initFaqEdit(faq.id)}
            >
            <EditIcon color="white" />
            </IconButton>

          <p  className={QAText}>{faq.q}</p>
          <h3><strong>A:</strong></h3>
          {/* <p className={QAText}>{faq.a}</p> */}
          <div className={QAText} dangerouslySetInnerHTML={{ __html: faq.a }} />

        </Paper>
      ))}
      {showAreYouSureDialog &&
        <AreYouSureModal
          message = {'Are you sure you want to delete this FAQ?'}
          open = {showAreYouSureDialog}
          executMethod = { ()=> deletFaq(currentFaq) }
          onClose = { ()=> setShowAreYouSureDialog(false) }
        ></AreYouSureModal>
      } 
    </>
  );
}

const styles = () => ({
  root: {
    width: '100%',
    border: '1px solid LightGray',
    padding: '10px',
    marginBottom: '10px'
  },
  rigthAlign: {
    float: 'right',
  },
  block: {
    display: 'block',
  },
  inline: {
    display: 'inline-block',
  },
  QAText: {
    marginLeft: '30px',
    '& p': {
      wordBreak: 'break-word',
      overflowWrap: 'break-word',
      whiteSpace: 'normal',
    }
  }
});

export default withStyles(styles)(FAQsList);
